// 遊戲商品牌覆寫：顯示名稱（多語系）與大廳 / 列表圖片
//
// 圖片：assets/providers/<provider>.png，以 import.meta.glob 一次載入，檔名即 provider 代號。
// 名稱：NAMES 表由 fatcat game_provider_translations.csv 生成，key 為 provider 代號，
//        值為各 locale 顯示名（locale 對齊 i18n available_locales：en / zh-CN）。
//        來源資料的 # 內部標記已在建表時去除；zh-CN 與 en 相同時省略，交由 fallback 補上。
// 未列於表中的 provider：沿用原代號當名稱，圖片走 ProviderThumb 的名稱 placeholder。

// 一次載入所有品牌圖，產生 { provider 代號 → 圖片 URL }
const imageModules = import.meta.glob('../assets/providers/*.png', { eager: true, import: 'default' })
const IMAGES = {}
for (const path in imageModules) {
  const code = path.split('/').pop().replace(/\.png$/, '')
  IMAGES[code] = imageModules[path]
}

// provider 代號 → { locale: 顯示名稱 }
const NAMES = {
  a5_lottery: { en: 'A5Lottery', 'zh-CN': 'A5彩票' },
  ae_fachai: { en: 'FaChai', 'zh-CN': 'FC發財' },
  ae_jili: { en: 'JILI' },
  ae_kingmaker: { en: 'KingMidas' },
  ae_play8: { en: 'PLAY8' },
  ae_slot: { en: 'AESlot', 'zh-CN': 'AE電子' },
  ae_yes_bingo: { en: 'Yellow Bat (OLD)' },
  afa: { en: 'AFA' },
  ag: { en: 'AG', 'zh-CN': 'AG亚游' },
  agin: { en: 'AG', 'zh-CN': 'AG亚游' },
  agin_sport: { en: 'AGIN Sports', 'zh-CN': 'AG亚游体育' },
  all: { en: 'ALL' },
  allbet: { en: 'ALLBET' },
  allbet_sw: { en: 'ALLBET' },
  amigo_gaming: { en: 'Amigo Gaming' },
  atg: { en: 'ATG' },
  att_hacksaw: { en: 'Hacksaw' },
  att_png: { en: 'Play N Go' },
  att_relax: { en: 'Relax' },
  att_ygg: { en: 'YGG Drasil' },
  avia: { en: 'AVIA', 'zh-CN': '泛亞' },
  bbin: { en: 'BBIN' },
  betby: { en: 'Betby' },
  betlink: { en: 'BetLink Sports', 'zh-CN': '博林体育' },
  bg_casino: { en: 'BG Casino', 'zh-CN': 'BG视讯' },
  bg_fishing: { en: 'BG Fishing', 'zh-CN': 'BG捕鱼' },
  bg_lottery: { en: 'BG', 'zh-CN': 'BG大遊' },
  bg_sport: { en: 'BG Sports', 'zh-CN': 'BG竞彩' },
  bg_sw: { en: 'BG', 'zh-CN': 'BG大遊' },
  bgaming_c02: { en: 'Bgaming' },
  bgsoft: { en: 'T1games' },
  bigpot: { en: 'Bigpot' },
  bigtimegaming_w01: { en: 'Big Time Gaming' },
  bigtimegaming_w02: { en: 'Big Time Gaming' },
  bingo888: { en: '888Bingo' },
  bingoniu: { en: 'BingoNiu', 'zh-CN': '牛牛宾果' },
  bng: { en: 'BNG' },
  bng_regulated: { en: 'BNG' },
  bole: { en: 'Bole(transfer)', 'zh-CN': '博乐棋牌(转帐)' },
  bole_sw: { en: 'BOLE', 'zh-CN': '博樂' },
  booming: { en: 'Booming' },
  bt_gaming: { en: 'BT Gaming' },
  bwin: { en: 'Winning', 'zh-CN': '必贏' },
  cg: { en: 'CG' },
  cg_sw: { en: 'CG' },
  cmd: { en: 'CMD368' },
  cockfight: { en: 'Cockfight' },
  cool_gaming: { en: 'Markor' },
  cq9: { en: 'CQ9' },
  cricket9: { en: '9Cricket' },
  crownm: { en: 'CROWN', 'zh-CN': '皇冠' },
  dc_hacksaw: { en: 'Hacksaw' },
  dg: { en: 'DG' },
  diamond_sport: { en: 'Diamond Sport' },
  digitain: { en: 'Digitain' },
  ds88: { en: 'DS88' },
  ds88_marble: { en: 'Ds88 Marble' },
  ea: { en: 'EA', 'zh-CN': 'EA 真人' },
  ebet: { en: 'ebet', 'zh-CN': 'eBET' },
  eighteen_peaches_o01: { en: '18Peaches' },
  esportsbull: { en: 'EsportsBull', 'zh-CN': '電競牛' },
  evo: { en: 'Evolution' },
  evo_regulated: { en: 'Evo' },
  evo_w01: { en: 'Evo' },
  evo_w02: { en: 'Evo' },
  evoplay_c02: { en: 'Evoplay' },
  fachai: { en: 'FaChai', 'zh-CN': 'Fachai' },
  fachai_regulated: { en: 'FaChai' },
  fast_spin: { en: 'FastSpin' },
  fatpit: { en: 'Fatpit' },
  fcc: { en: 'LOTUS', 'zh-CN': 'LOTUS 真人' },
  fg: { en: 'Fun Gaming' },
  fiesta: { en: 'Fiesta' },
  fiesta_fruit: { en: 'Fiesta Fruit' },
  five_g: { en: '5G' },
  five_g_regulated: { en: '5G' },
  funta_gaming: { en: 'Funta Gaming' },
  funta_gaming_regulated: { en: 'Funta Gaming' },
  gamatron: { en: 'Gamatron' },
  game_art: { en: 'GameArt', 'zh-CN': 'GameArt 电子' },
  gamingmart: { en: 'GM' },
  gemini: { en: 'Gemini' },
  gemini_live: { en: 'Gemini Live' },
  gemini_live_a001: { en: 'Gemini Live' },
  gemini_live_regulated: { en: 'Gemini Live' },
  gemini_marble: { en: 'Gemini Marble' },
  gemini_marble_regulated: { en: 'Gemini Marble Regulated' },
  gemini_regulated: { en: 'Gemini' },
  gemini_sport: { en: 'Gemini Sport' },
  gemini_sport_regulated: { en: 'Gemini Sport' },
  gg: { en: 'GG Lottery', 'zh-CN': 'GG 彩票' },
  glc: { en: 'GLC' },
  gs_ailive_casino: { en: 'AI LIVE CASINO' },
  gs_epicwin: { en: 'EPICWIN' },
  gs_live22: { en: 'LIVE22' },
  gs_uuslot: { en: 'UUSlot' },
  gs_wowgaming: { en: 'Afa Slots' },
  hacksaw: { en: 'Hacksaw' },
  hacksaw_c01: { en: 'Hacksaw' },
  hacksaw_c01_regulated: { en: 'Hacksaw' },
  hacksaw_c02: { en: 'Hacksaw' },
  hacksaw_h01: { en: 'Hacksaw' },
  hacksaw_h02: { en: 'Hacksaw' },
  hc: { en: 'GB Gaming', 'zh-CN': 'GB' },
  hotdog_gaming: { en: 'Hotdog Gaming' },
  hugewin: { en: 'Hugewin' },
  i8: { en: 'i8Games', 'zh-CN': 'i8' },
  ibcbet: { en: 'SABA', 'zh-CN': '沙巴' },
  icg: { en: 'AT' },
  ideal_gaming_o01: { en: 'Ideal Gaming' },
  imsb: { en: 'IM Sports', 'zh-CN': 'IM' },
  jdb: { en: 'JDB' },
  jdb_regulated: { en: 'JDB' },
  jili: { en: 'JILI', 'zh-CN': 'JILI 吉利' },
  jili_regulated: { en: 'JILI' },
  jinbao: { en: 'Jinbao', 'zh-CN': '金堡彩票' },
  jizhi_lottery: { en: 'JI ZHI', 'zh-CN': '極致' },
  jollysport: { en: 'Jollysport' },
  jsl: { en: 'JSL' },
  ka: { en: 'KA Gaming' },
  ku: { en: 'KU Live', 'zh-CN': 'KU 真人' },
  kx: { en: 'KX', 'zh-CN': 'KX 凱旋' },
  kygaming: { en: 'KY', 'zh-CN': '開元' },
  leg: { en: 'LEG', 'zh-CN': 'LEG 樂遊' },
  m8: { en: 'M8 Sports', 'zh-CN': 'M8 体育' },
  maha_gaming: { en: 'Maha Gaming' },
  marble: { en: 'Gemini Marble' },
  mg: { en: 'MG' },
  mg2: { en: 'MG' },
  mg_live_grand: { en: 'Microgaming Live' },
  mg_poker: { en: 'MgPoker', 'zh-CN': 'MG棋牌' },
  mg_zf: { en: 'Micro Gaming' },
  mgm_sports: { en: 'MGM Sport' },
  n2: { en: 'N2Live' },
  netent_w01: { en: 'Netent' },
  netent_w02: { en: 'Netent' },
  nextspin: { en: 'Nextspin' },
  ng_avia: { en: 'NG Avia', 'zh-CN': 'NG 泛亚电竞' },
  ng_bbin: { en: 'BBIN' },
  ng_esb: { en: 'NG Esportsbull', 'zh-CN': 'NG 电竞牛' },
  ng_lebo: { en: 'LEBO', 'zh-CN': 'LEBO 真人' },
  ng_og: { en: 'OG', 'zh-CN': 'OG 真人' },
  ng_vr: { en: 'NG VR', 'zh-CN': 'NG VR彩票' },
  nine_wicket: { en: '9wicket(old)' },
  nine_wicket2: { en: '9wicket' },
  nlc: { en: 'NLC' },
  nlc_regulated: { en: 'NoLimitCity' },
  nolimitcity_w01: { en: 'No Limit City' },
  nolimitcity_w02: { en: 'No Limit City' },
  ob_lottery: { en: 'OB Lottery', 'zh-CN': 'OB 彩票' },
  ob_poker: { en: 'OB Poker', 'zh-CN': 'OB 棋牌' },
  ob_sport: { en: 'OB Sports', 'zh-CN': 'OB 體育' },
  octoplay_c01: { en: 'Octoplay' },
  octoplay_c02: { en: 'Octoplay' },
  odin: { en: 'Odin' },
  odin2: { en: 'Odin' },
  og: { en: 'OG' },
  oke_live: { en: 'OKE Live' },
  onebet: { en: '1bet' },
  onlive: { en: 'Onlive' },
  onlive_regulated: { en: 'Onlive' },
  onsexy_casino: { en: 'Onsexy' },
  pg: { en: 'PG' },
  pg_o01: { en: 'PG' },
  pg_o02: { en: 'PG' },
  pg_p01: { en: 'PG' },
  pg_p01_regulated: { en: 'PG' },
  pinnacle_solution: { en: 'Pinnacle' },
  playstar: { en: 'Playstar' },
  playstar_regulated: { en: 'Playstar' },
  playtech: { en: 'Playtech' },
  playtech_regulated: { en: 'Playtech' },
  pokerq: { en: 'PokerQ' },
  pp: { en: 'PP' },
  pragmatic_play: { en: 'PP' },
  pragmatic_play_pop_o01: { en: 'PP POP' },
  pragmatic_play_pop_o02: { en: 'PP POP' },
  pragmatic_play_regulated: { en: 'PP' },
  pragmatic_play_t01: { en: 'PragmaticPlay' },
  pragmatic_play_t02: { en: 'PragmaticPlay' },
  pronet_sportsbook: { en: 'PG Sport' },
  pt: { en: 'PT' },
  qt: { en: 'QTech', 'zh-CN': 'QTech 电子' },
  qtech: { en: 'QTech' },
  r128: { en: 'R128' },
  redtiger_w01: { en: 'Red Tiger' },
  redtiger_w02: { en: 'Red Tiger' },
  relax: { en: 'Relax' },
  relax_c01: { en: 'Relax' },
  relax_c01_regulated: { en: 'Relax' },
  relax_c02: { en: 'Relax' },
  rg: { en: 'RG' },
  rich88: { en: 'RICH88' },
  rmg: { en: 'Rich Man Game', 'zh-CN': '大富翁棋牌' },
  rsg: { en: 'RSG' },
  rtg: { en: 'RTG', 'zh-CN': 'RTG 电子' },
  rtg_regulated: { en: 'RTG' },
  rtg_v2: { en: 'Magic Macau' },
  s128: { en: 'Digmaan' },
  sa: { en: 'SA' },
  sa_regulated: { en: 'SA' },
  sa_sw: { en: 'SA' },
  sb747: { en: 'SB747' },
  sbo: { en: 'SBO', 'zh-CN': '利記' },
  sbo568: { en: '568WinSports', 'zh-CN': '利记568' },
  seventy_seven_gaming_o01: { en: '77gaming' },
  seventy_seven_gaming_o02: { en: '77gaming' },
  sexy: { en: 'SEXY CASINO' },
  shadylady_w01: { en: 'Shadylady' },
  slotmill_c02: { en: 'Slotmill' },
  smartsoft_c01: { en: 'Smartsoft' },
  smartsoft_c02: { en: 'Smartsoft' },
  spadegaming: { en: 'Spadegaming' },
  sparkgame_o01: { en: 'SparkGame' },
  spribe_c01: { en: 'Spribe' },
  spribe_c02: { en: 'Spribe' },
  ssb_lottery: { en: 'WG', 'zh-CN': '鑫寶' },
  ssb_sport: { en: 'WG', 'zh-CN': '鑫寶' },
  sunbet: { en: 'Sunbet', 'zh-CN': 'SUNBET' },
  sunbettgp: { en: 'Sunbet TGP', 'zh-CN': '申博真人' },
  super_sport: { en: 'SUPER' },
  super_up: { en: 'SUPER UP', 'zh-CN': 'UP反波膽' },
  tada: { en: 'Tada' },
  taparoo_w01: { en: 'Tap A Roo' },
  taparoo_w02: { en: 'Tap A Roo' },
  tcg: { en: 'TCG', 'zh-CN': 'TCG彩票' },
  tcm_o01: { en: 'TCM' },
  tcm_o02: { en: 'TCM' },
  titigaming: { en: 'Titi Gaming' },
  tomhorn: { en: 'TomHorn' },
  top_player: { en: 'TopPlayer' },
  tpg: { en: 'TPG' },
  tpg_regulated: { en: 'TPG' },
  ts: { en: 'TS', 'zh-CN': '九州' },
  turbogames_c02: { en: 'Turbogames' },
  twoj: { en: 'Two J' },
  ug: { en: 'UnitedGaming' },
  ug2: { en: 'UnitedGaming v2' },
  ugs_pg: { en: 'Ugs PG' },
  updown: { en: 'UpDown' },
  vb: { en: 'Vb Esports', 'zh-CN': '威博电竞' },
  via: { en: 'ViA' },
  voltent_c02: { en: 'Voltent' },
  vp: { en: 'VP' },
  vplus: { en: 'VPlus' },
  vr: { en: 'VR' },
  vsl: { en: 'VSL' },
  winslot: { en: 'Winslot' },
  wm: { en: 'WM' },
  wm_live: { en: 'Wm Live', 'zh-CN': 'WM真人' },
  ws168: { en: 'Ws168' },
  xg: { en: 'XG' },
  xj_agile_bet: { en: 'XJ Sports', 'zh-CN': '小金体育' },
  yellow_bat_a001: { en: 'Yellow Bat_95' },
  yellow_bat_regulated: { en: 'Yellow Bat' },
  yes_bingo: { en: 'Yellow Bat' },
  ygg_c01: { en: 'YGG' },
  ygg_c01_regulated: { en: 'YGG' },
  ygg_c02: { en: 'YGG' },
  youbet_lotto: { en: 'YouBet Lotto' },
}

// 顯示名稱：依 locale 取，缺該語系回退 en，再回退原代號
export function providerDisplayName(provider, locale = 'en') {
  const entry = NAMES[provider]
  if (!entry) return provider || ''
  return entry[locale] || entry.en || provider || ''
}

// 品牌圖片：有則回 URL，無則回 null（由 ProviderThumb fallback 成名稱 placeholder）
export function providerImage(provider) {
  return IMAGES[provider] || null
}
